import dayGridPlugin from "@fullcalendar/daygrid";

export default dayGridPlugin;
